export { default } from "./ClickTable";
export { Table } from "./ClickTable";
